import '@selectize/selectize';
import Form from '../components/advanced-search';


import '../css/search-forms.css'


export default function AdvancedSearchPage() {
  return (
    <div className='container'>
        <h1 style={{textAlign:"center"}}>Advanced Search</h1>
        <br/>
      <Form  />
    </div>
  );
}